if (!window.routes) {
  window.routes = {
    cart_add_url: "/cart/add.js",
    cart_change_url: "/cart/change.js",
    cart_update_url: "/cart/update.js",
    cart_url: "/cart.js",
  };
}

const ShopifyMoneyFormat = {
  format(cents) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    const moneyFormat =
      window.theme?.moneyFormat ||
      window.Shopify?.money_format ||
      "{{amount}} PLN";
    const amount = cents / 100;

    let value = "";
    const formatString =
      moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || "amount";

    switch (formatString) {
      case "amount":
        value = amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        break;
      case "amount_no_decimals":
        value = Math.round(amount)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        break;
      case "amount_with_comma_separator":
        value = amount
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = Math.round(amount)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
        break;
      case "amount_with_space_separator":
        value = amount
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        break;
      case "amount_no_decimals_with_space_separator":
        value = Math.round(amount)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
        break;
      default:
        value = amount.toFixed(2);
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  },
};

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items");
      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = this.debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.setupQuantityButtons();
  }

  setupQuantityButtons() {
    this.addEventListener("click", (e) => {
      const button = e.target.closest(
        ".brutalist-quantity-button, .quantity__button"
      );
      if (!button) return;

      e.preventDefault();
      const selector = button.closest(
        ".brutalist-quantity-selector, quantity-input"
      );
      const input = selector?.querySelector("input");
      if (!input) return;

      const currentValue = parseInt(input.value, 10) || 0;
      const newValue =
        button.name === "plus"
          ? currentValue + 1
          : Math.max(0, currentValue - 1);

      if (newValue !== currentValue) {
        input.value = newValue;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange(event) {
    const target = event.target;
    if (target.name === "updates[]") {
      event.preventDefault();
      this.updateQuantity(
        target.dataset.index,
        target.value,
        document.activeElement.getAttribute("name")
      );
    }
  }

  getSectionsToRender() {
    const sections = [];

    const mainCartItems = document.getElementById("main-cart-items");
    if (mainCartItems?.dataset.id) {
      sections.push({
        id: "main-cart-items",
        section: mainCartItems.dataset.id,
        selector: "#main-cart-items",
      });
    }

    return sections;
  }

  getSectionInnerHTML(html, selector) {
    const element = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return element ? element.innerHTML : null;
  }

  renderSections(state) {
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = state.sections?.[section.section];
      if (!target || !html) return;

      const inner = this.getSectionInnerHTML(html, section.selector);
      if (inner !== null) {
        target.innerHTML = inner;
      }
    });
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line: parseInt(line),
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_change_url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    })
      .then((response) => {
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new TypeError("Response was not JSON");
        }
        return response.json();
      })
      .then((state) => {
        console.log("Cart state:", state);

        if (state.item_count === 0) {
          window.location.reload();
          return;
        }

        this.renderSections(state);
        this.updateCartFromState(state, line, name);
      })
      .catch((error) => {
        console.error("Cart update failed:", error);

        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );

        const errors = document.getElementById("cart-errors");
        if (errors) {
          errors.textContent = "Wystąpił błąd podczas aktualizacji koszyka.";
          errors.style.display = "block";

          setTimeout(() => {
            errors.style.display = "none";
          }, 5000);
        }

        this.disableLoading(line);
      });
  }

  updateCartFromState(state, line, name) {
    this.updateCartCount(state.item_count);

    state.items.forEach((item, index) => {
      const lineIndex = index + 1;
      this.updateLineItem(lineIndex, item);
    });

    this.updateCartTotals(state);
    this.updateCartIcon(state.item_count);
    this.updateLiveRegions(line, state.item_count);
    this.disableLoading(line);

    setTimeout(() => {
      const lineItem = document.getElementById(`CartItem-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        lineItem.querySelector(`[name="${name}"]`).focus();
      }
    }, 100);
  }

  updateCartCount(itemCount) {
    const cartCount = document.querySelector(".brutalist-cart-count");
    if (!cartCount) return;

    let text = "";
    if (itemCount === 1) {
      text = `${itemCount} produkt`;
    } else if (itemCount > 1 && itemCount < 5) {
      text = `${itemCount} produkty`;
    } else {
      text = `${itemCount} produktów`;
    }
    cartCount.textContent = text;
  }

  updateLineItem(lineIndex, item) {
    const lineItem = document.getElementById(`CartItem-${lineIndex}`);
    if (!lineItem) return;

    const quantityInput = lineItem.querySelector(`#Quantity-${lineIndex}`);
    if (quantityInput) {
      quantityInput.value = item.quantity;
    }

    const itemTotal = lineItem.querySelector(".brutalist-item-total");
    if (itemTotal) {
      itemTotal.innerHTML = ShopifyMoneyFormat.format(item.final_line_price);
    }

    if (window.baCurr && typeof window.baCurr.repeat === "function") {
      window.baCurr.repeat();
    }
  }

  updateCartTotals(state) {
    const summarySubtotal = document.querySelector(
      ".brutalist-summary-row .brutalist-summary-value"
    );
    if (summarySubtotal) {
      summarySubtotal.innerHTML = ShopifyMoneyFormat.format(
        state.total_price
      );
    }

    const summaryTotal = document.querySelector(
      ".brutalist-summary-total-value"
    );
    if (summaryTotal) {
      summaryTotal.innerHTML = ShopifyMoneyFormat.format(state.total_price);
    }

    if (window.baCurr && typeof window.baCurr.repeat === "function") {
      window.baCurr.repeat();
    }
  }

  updateCartIcon(itemCount) {
    const cartBubble = document.querySelector(
      "#cart-icon-bubble .cart-count-bubble"
    );

    if (cartBubble) {
      if (itemCount > 0) {
        cartBubble.textContent = itemCount > 99 ? "99+" : itemCount;
        cartBubble.style.display = "flex";
      } else {
        cartBubble.textContent = "";
        cartBubble.style.display = "none";
      }
    }
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`);

      if (lineItemError && quantityElement) {
        const errorText = lineItemError.querySelector(".cart-item__error-text");
        if (errorText) {
          errorText.innerHTML = `Nie możesz dodać więcej tego produktu. Dostępna ilość: ${quantityElement.value}`;
        }
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", "true");
    }

    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", "false");
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", "true");
      }, 1000);
    }
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items");
    if (mainCartItems) {
      mainCartItems.classList.add("cart__items--disabled");
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    cartItemElements.forEach((overlay) => overlay.classList.remove("hidden"));

    document.activeElement?.blur();

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute("aria-hidden", "false");
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("main-cart-items");
    if (mainCartItems) {
      mainCartItems.classList.remove("cart__items--disabled");
    }

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          this.debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(window.routes.cart_update_url, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body,
            });
          }, 300)
        );
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
    }
  );
}

class CartDrawerItems extends HTMLElement {
  constructor() {
    super();

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange(event) {
    const target = event.target;
    if (target.name === "updates[]") {
      event.preventDefault();
      this.updateQuantity(
        target.dataset.index,
        target.value,
        document.activeElement.getAttribute("name")
      );
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line: parseInt(line),
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    })
      .then((response) => response.json())
      .then((state) => {
        console.log("Cart drawer state:", state);

        if (state.item_count === 0) {
          this.classList.add("is-empty");
          const drawer = document.querySelector("cart-drawer");
          if (drawer) {
            setTimeout(() => {
              drawer.close();
            }, 300);
          }
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id);
          if (
            elementToReplace &&
            state.sections &&
            state.sections[section.section]
          ) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              state.sections[section.section],
              section.selector
            );
          }
        });

        this.updateCartIcon(state.item_count);
        this.disableLoading(line);
      })
      .catch((error) => {
        console.error("Cart drawer update failed:", error);
        this.disableLoading(line);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer-CartItems",
        section: "cart-drawer",
        selector: ".drawer__contents",
      },
      {
        id: "CartDrawer-Footer",
        section: "cart-drawer",
        selector: ".drawer__footer",
      },
    ];
  }

  updateCartIcon(itemCount) {
    const cartBubble = document.querySelector(
      "#cart-icon-bubble .cart-count-bubble"
    );

    if (cartBubble) {
      if (itemCount > 0) {
        cartBubble.textContent = itemCount > 99 ? "99+" : itemCount;
        cartBubble.style.display = "flex";
      } else {
        cartBubble.textContent = "";
        cartBubble.style.display = "none";
      }
    }
  }

  enableLoading(line) {
    const lineItem = this.querySelector(
      `#CartDrawer-Item-${line} .loading-overlay`
    );
    if (lineItem) {
      lineItem.classList.remove("hidden");
    }

    const allInputs = this.querySelectorAll("input, button");
    allInputs.forEach((input) => {
      input.disabled = true;
    });
  }

  disableLoading(line) {
    setTimeout(() => {
      const lineItem = this.querySelector(
        `#CartDrawer-Item-${line} .loading-overlay`
      );
      if (lineItem) {
        lineItem.classList.add("hidden");
      }

      const allInputs = this.querySelectorAll("input, button");
      allInputs.forEach((input) => {
        input.disabled = false;
      });
    }, 100);
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
